import { Backdrop, CircularProgress } from "@mui/material";
import useBackdrop from "hooks/useBackdrop";

const GlobalBackdrop = () => {
    const { backdropLoading, closeBackdrop } = useBackdrop();

    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropLoading}
            onClick={closeBackdrop}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default GlobalBackdrop;
